/**
 * Processes HTML content to extract and set intrinsic widths for images
 * @param {string} content - The HTML content to process
 * @returns {string} - The processed HTML content
 */
export function processImageWidths(content) {
  if (!content) return "";

  // Create a temporary div to parse the HTML
  const div = document.createElement("div");
  div.innerHTML = content;

  // Find all images
  const images = div.getElementsByTagName("img");
  Array.from(images).forEach((img) => {
    // Get the width from the width attribute
    const declaredWidth = parseInt(img.getAttribute("width"), 10);
    if (declaredWidth) {
      img.style.setProperty("--intrinsic-width", `${declaredWidth}px`);
    } else {
      // Fallback to parsing srcset if width attribute isn't available
      const srcset = img.getAttribute("srcset");
      if (srcset) {
        // Get the largest non-scaled image width
        const widths = srcset
          .split(",")
          .map((src) => {
            const match = src.trim().match(/(\d+)w$/);
            return match ? parseInt(match[1], 10) : 0;
          })
          .filter((w) => w < 1500); // Filter out scaled images

        if (widths.length) {
          const maxWidth = Math.max(...widths);
          img.style.setProperty("--intrinsic-width", `${maxWidth}px`);
        }
      }
    }
  });

  return div.innerHTML;
}
